import React, { useState } from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import { MaterialUIGridContainer } from "core/MaterialUI";
import Tooltip from "core/Tooltip";
import {
    DownloadSize,
    CurrentDownloadSize,
    OpenSizeOptions,
    ChangeDownloadSize,
    ChangeDownloadSizeItem
} from "./styles";

import { DOWNLOAD_SIZES, SIZE_LABELS } from "icons/helpers";

const ChangeSize = ({ downloadSize, setDownloadSize }) => {
    const changeSizeTooltip = (
        <MaterialUIGridContainer
            mobileMaxPadding={0}
            tabletMaxPadding={0}
            desktopMinPadding={0}
        >
            {DOWNLOAD_SIZES.reduce(
                (sizes, size) => [
                    ...sizes,
                    <Grid key={`label-${size}`} item xs={5}>
                        {SIZE_LABELS[size]}
                    </Grid>,
                    <Grid key={`value-${size}`} item xs={7}>
                        <ChangeDownloadSizeItem
                            onClick={() => setDownloadSize(size)}
                        >
                            {size}px x {size}px
                        </ChangeDownloadSizeItem>
                    </Grid>
                ],
                []
            )}
        </MaterialUIGridContainer>
    );

    return (
        <DownloadSize>
            <CurrentDownloadSize data-testid="selected-download-size">
                {downloadSize}px x {downloadSize}px
            </CurrentDownloadSize>
            <ChangeDownloadSize>
                <Tooltip darkMode message={changeSizeTooltip}>
                    <OpenSizeOptions>change size</OpenSizeOptions>
                </Tooltip>
            </ChangeDownloadSize>
        </DownloadSize>
    );
};

ChangeSize.propTypes = {
    downloadSize: PropTypes.number.isRequired,
    setDownloadSize: PropTypes.func.isRequired
};

export default ChangeSize;
